import React from 'react';

import { Flex, Box } from '@chakra-ui/react';

import { TextBodyMedium, TextHeader4 } from 'uiToolkitV1/Typography';

function GradientCard({ children, title = '', subtitle = '', containerProps = {}, childrenContainerProps = {} }) {
  return (
    <Flex
      direction="column"
      borderRadius="8px"
      width="100%"
      padding="1px"
      bgGradient="linear(to-r, rgba(0, 142, 240, 0.2), rgba(236, 59, 100, 0.2), rgba(255, 194, 0, 0.2),rgba(92, 196, 97, 0.2))"
      {...containerProps}
    >
      <Box background="white" width="100%" borderRadius="7px" padding="4px">
        <Flex
          padding="12px 16px"
          direction="column"
          bgGradient="linear(to-r, rgba(0, 142, 240, 0.02), rgba(236, 59, 100, 0.02), rgba(255, 194, 0, 0.02), rgba(92, 196, 97, 0.02))"
        >
          <TextHeader4 bold>{title}</TextHeader4>
          {subtitle && <TextBodyMedium fontSize="12px">{subtitle}</TextBodyMedium>}
        </Flex>
        <Flex
          height="1px"
          borderTop="1px transparent"
          mx="5px"
          bgGradient="linear(to-r, rgba(0, 142, 240, 0.2), rgba(236, 59, 100, 0.2), rgba(255, 194, 0, 0.2),rgba(92, 196, 97, 0.2))"
        />

        <Flex
          padding="12px"
          width="100%"
          bgGradient="linear(to-r, rgba(0, 142, 240, 0.02), rgba(236, 59, 100, 0.02), rgba(255, 194, 0, 0.02), rgba(92, 196, 97, 0.02))"
          {...childrenContainerProps}
        >
          {children}
        </Flex>
      </Box>
    </Flex>
  );
}
export default GradientCard;
